<template>
  <div class="c-solutionInfo relative">
    <div class="c-panelsTab__shadow"></div>
    <div class="c-content__imageBlockBottom c-standard" style='padding: 50px 0 0'>
      <div class="c-content__imageBlockBottom--text">
        <h3 class='title_h3'>
          {{ theme[type].banner.title }}
        </h3>
      </div>
      <div class="c-content__imageBlockBottom--image">
        <img :src="theme[type].banner.img" :alt="theme[type].banner.title">
      </div>
      <p class="c-panelsTab__text">{{ theme[type].banner.content }}</p>
      <div class="c-program">
        <img :src="theme[type].program.image_en" alt="" v-if="languageDefault == 'en_us'">
        <img :src="theme[type].program.image_de" alt="" v-else-if="languageDefault == 'de_de'">
        <img :src="theme[type].program.image" alt="" v-else>
        <div class="c-program__btn" v-for="(item, i) in theme[type].program.btn" :key="i" :style="{top: item.x, left: item.y, width: item.width + '%', height: item.height + '%'}" @mouseover="hoverTips(item)" @mouseout="popupActive = false"></div>
        <div class="c-program__popup c-program__popup--pension" :class="{'is-active': popupActive}" :style="{top: popup.top, left: popup.left, right: popup.right, bottom: popup.bottom}">
          <!-- <h4>{{popup.content.title}}</h4>
          <img :src="popup.content.img" alt=""> -->
          <p>{{popup.content.text}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'solutionInfo',
    props: ['type'],
    data(){
      return{
        languageDefault: localStorage.getItem('lang') || 'zh_cn',
        theme: [
          {
            banner: {
              img: require('../../assets/img/solution_homecare.jpg'),
              title: this.$t('program_pension.theme_1.title'),
              content: this.$t('program_pension.theme_1.content')
            },
            program: {
              image: require('../../assets/img/program_pension/homecare/solution_homecare_sys.jpg'),
              image_en: require('../../assets/img/program_pension/homecare/solution_homecare_sys_en.jpg'),
              image_de: require('../../assets/img/program_pension/homecare/solution_homecare_sys_de.jpg'),
              btn:[
                {x: '33.9%',y : '24.1%', width: '10.4', height: '6.4', content: {title: this.$t('program_pension.theme_1.program.program_1.title'), img:'', text: this.$t('program_pension.theme_1.program.program_1.content')}},
                {x: '43.5%',y : '21.4%', width: '10.4', height: '6.4', content: {title: this.$t('program_pension.theme_1.program.program_2.title'), img:'', text: this.$t('program_pension.theme_1.program.program_2.content')}},
                {x: '53.3%',y : '21.4%', width: '10.4', height: '6.4', content: {title: this.$t('program_pension.theme_1.program.program_3.title'), img:'', text: this.$t('program_pension.theme_1.program.program_3.content')}},
                {x: '63%',  y : '24.1%', width: '10.4', height: '6.4', content: {title: this.$t('program_pension.theme_1.program.program_4.title'), img:'', text: this.$t('program_pension.theme_1.program.program_4.content')}},
                {x: '36.8%',y : '66.4%', width: '10.4', height: '6.4', content: {title: this.$t('program_pension.theme_1.program.program_5.title'), img:'', text: this.$t('program_pension.theme_1.program.program_5.content')}},
                {x: '49.1%',y : '68.4%', width: '10.4', height: '6.4', content: {title: this.$t('program_pension.theme_1.program.program_6.title'), img:'', text: this.$t('program_pension.theme_1.program.program_6.content')}},
                {x: '61.3%',y : '66.4%', width: '10.4', height: '6.4', content: {title: this.$t('program_pension.theme_1.program.program_7.title'), img:'', text: this.$t('program_pension.theme_1.program.program_7.content')}},
              ]
            }
          },
          {
            banner: {
              img: require('../../assets/img/solution_communitycare.jpg'),
              title: this.$t('program_pension.theme_2.title'),
              content: this.$t('program_pension.theme_2.content')
            },
            program: {
              image: require('../../assets/img/program_pension/institutionalcare/solution_institutionalcare_sys.jpg'),
              image_en: require('../../assets/img/program_pension/institutionalcare/solution_institutionalcare_sys_en.jpg'),
              image_de: require('../../assets/img/program_pension/institutionalcare/solution_institutionalcare_sys_de.jpg'),
              btn:[
                {x: '35.9%',y : '24.1%', width: '10.4', height: '6.4', content: {title: this.$t('program_pension.theme_2.program.program_1.title'), img:'', text: this.$t('program_pension.theme_2.program.program_1.content')}},
                {x: '45.5%',y : '21.4%', width: '10.4', height: '6.4', content: {title: this.$t('program_pension.theme_2.program.program_2.title'), img:'', text: this.$t('program_pension.theme_2.program.program_2.content')}},
                {x: '55.3%',y : '21.4%', width: '10.4', height: '6.4', content: {title: this.$t('program_pension.theme_2.program.program_3.title'), img:'', text: this.$t('program_pension.theme_2.program.program_3.content')}},
                {x: '65%',  y : '24.1%', width: '10.4', height: '6.4', content: {title: this.$t('program_pension.theme_2.program.program_4.title'), img:'', text: this.$t('program_pension.theme_2.program.program_4.content')}},
                {x: '29.3%',y : '63.8%', width: '10.4', height: '6.4', content: {title: this.$t('program_pension.theme_2.program.program_5.title'), img:'', text: this.$t('program_pension.theme_2.program.program_5.content')}},
                {x: '39.8%',y : '67.1%', width: '10.4', height: '6.4', content: {title: this.$t('program_pension.theme_2.program.program_6.title'), img:'', text: this.$t('program_pension.theme_2.program.program_6.content')}},
                {x: '50.2%',y : '68.8%', width: '10.4', height: '6.4', content: {title: this.$t('program_pension.theme_2.program.program_7.title'), img:'', text: this.$t('program_pension.theme_2.program.program_7.content')}},
                {x: '61.3%',y : '67.1%', width: '10.4', height: '6.4', content: {title: this.$t('program_pension.theme_2.program.program_8.title'), img:'', text: this.$t('program_pension.theme_2.program.program_8.content')}},
                {x: '71.7%',y : '63.8%', width: '10.4', height: '6.4', content: {title: this.$t('program_pension.theme_2.program.program_9.title'), img:'', text: this.$t('program_pension.theme_2.program.program_9.content')}},
              ]
            }
          },
          {
            banner: {
              img: require('../../assets/img/solution_institutionalcare.jpg'),
              title: this.$t('program_pension.theme_3.title'),
              content: this.$t('program_pension.theme_3.content')
            },
            program: {
              image: require('../../assets/img/program_pension/communitycare/solution_communitycare_sys.jpg'),
              image_en: require('../../assets/img/program_pension/communitycare/solution_communitycare_sys_en.jpg'),
              image_de: require('../../assets/img/program_pension/communitycare/solution_communitycare_sys_de.jpg'),
              btn:[
                {x: '35.6%',y : '23.4%', width: '10.4', height: '6.4', content: {title: this.$t('program_pension.theme_3.program.program_1.title'), img:'', text: this.$t('program_pension.theme_3.program.program_1.content')}},
                {x: '47.2%',y : '21.8%', width: '10.4', height: '6.4', content: {title: this.$t('program_pension.theme_3.program.program_2.title'), img:'', text: this.$t('program_pension.theme_3.program.program_2.content')}},
                {x: '58.8%',y : '23.4%', width: '10.4', height: '6.4', content: {title: this.$t('program_pension.theme_3.program.program_3.title'), img:'', text: this.$t('program_pension.theme_3.program.program_3.content')}},
                {x: '41.4%',y : '68.1%', width: '10.4', height: '6.4', content: {title: this.$t('program_pension.theme_3.program.program_4.title'), img:'', text: this.$t('program_pension.theme_3.program.program_4.content')}},
                {x: '52.8%',y : '68%',   width: '10.4', height: '6.4', content: {title: this.$t('program_pension.theme_3.program.program_5.title'), img:'', text: this.$t('program_pension.theme_3.program.program_5.content')}},
              ]
            }
          },
        ],
        popup:{
          content: '',
          top: 'auto',
          bottom: 'auto',
          left: 'auto',
          right: 'auto'
        },
        popupActive: false
      }
    },
    computed: {

    },
    methods:{
      hoverTips(item){
        this.popup.content = item.content
        let x = parseFloat(item.x.split('%')[0])
        let y = parseFloat(item.y.split('%')[0])

        let direction
        if (x >= 50) {
          if (y >= 50) {
            direction = 'leftTop'
          } else {
            direction = 'RightTop'
          }
        } else {
          if (y >= 50) {
            direction = 'leftBottom'
          } else {
            direction = 'RightBottom'
          }
        }
        switch (direction) {
          case 'leftTop':
            this.popup = {
              content: item.content,
              top: 'auto',
              bottom: (100 - (parseFloat(item.x.split('%')[0]))) + '%',
              left: 'auto',
              right: (100 - (parseFloat(item.y.split('%')[0])) - parseFloat(item.width)) + '%'
            }
            break;
          case 'leftBottom':
            this.popup = {
              content: item.content,
              top: (parseFloat(item.x.split('%')[0]) + parseFloat(item.height)) + '%',
              bottom: 'auto',
              left: 'auto',
              right: (100 - (parseFloat(item.y.split('%')[0])) - parseFloat(item.width)) + '%'
            }
            break;
          case 'RightTop':
            this.popup = {
              content: item.content,
              top: 'auto',
              bottom: (100 - (parseFloat(item.x.split('%')[0]))) + '%',
              left: parseFloat(item.y.split('%')[0]) + '%',
              right: 'auto'
            }
            break;
          case 'RightBottom':
            this.popup = {
              content: item.content,
              top: (parseFloat(item.x.split('%')[0]) + parseFloat(item.height)) + '%',
              bottom: 'auto',
              left: parseFloat(item.y.split('%')[0]) + '%',
              right: 'auto'
            }
            break;
        }
        this.popupActive = true
      },
    },
    created(){

    }
  }
</script>

<style>


</style>
